import {cyclicDeserialize} from "./cyclic_serialization";
import {JdkInfo} from "./project";

export const DEFAULT_JDK_PATH = "/assets/jdk8-info.json";

let cachedJdk: JdkInfo | null = null;
let downloading = false;
const pending: {res: (value: JdkInfo) => void; rej: (reason: any) => void}[] =
	[];

/**
 * Asynchronously load the JDK.
 * @param thunk The function to call to fetch the JDK.
 */
export async function loadJdk(thunk: () => Promise<any>): Promise<JdkInfo> {
	if (cachedJdk) return cachedJdk;

	if (downloading) {
		// don't request multiple times!
		return new Promise((res, rej) => {
			pending.push({res, rej});
		});
	}

	try {
		downloading = true;

		const unserialized = await thunk();
		cachedJdk = cyclicDeserialize(unserialized);

		for (const {res} of pending) res(cachedJdk!);
		return cachedJdk!;
	} catch (e) {
		for (const {rej} of pending) rej(e);
		throw e;
	}
}
